export const SET_DEVICE_TAB_ID = 'HUB_CONNECTION_STATE.SET_DEVICE_TAB_ID';
